export const translations = {
  fr: {
    header: {
      subtitle: "Chirurgie Plastique et Reconstructrice de la Face",
      nav: {
        interventions: "Interventions",
        cabinet: "Le cabinet",
        actualites: "Actualités",
        contact: "Contact",
      },
    },
    hero: {
      title: "Chirurgien Esthétique",
      tagline:
        "Chirurgien plasticien spécialiste de la face, pour une approche personnalisée et naturelle",
    },
    interventions: {
      heading: "Interventions",
      tocLabel: "Accès rapide aux interventions",
      tocIntro: "Aller directement à :",
      labels: {
        overview: "Ce que traite cette intervention",
        consultation: "Le déroulement de la consultation",
        expect: "À quoi s'attendre",
      },
      list: [
        {
          id: 1,
          slug: "rhinoplastie",
          title: "Rhinoplastie",
          overview:
            "La rhinoplastie corrige la forme, les proportions ou les asymétries du nez : bosse dorsale, pointe tombante ou bulbeuse, déviation, ou nez trop marqué par rapport au reste du visage. Elle peut aussi traiter une gêne respiratoire liée à une cloison nasale déviée, en associant un geste fonctionnel au geste esthétique.",
          consultation:
            "La première consultation permet d'examiner l'anatomie du nez, la qualité de la peau et la fonction respiratoire, et d'écouter précisément vos attentes. Le Dr. Oliver présente les techniques envisageables — rhinoplastie structurelle, ultrasonique, avec ou sans ostéotomies — et simule si besoin le résultat attendu pour vérifier que le projet reste réaliste et cohérent avec votre visage.",
          expect:
            "L'intervention se déroule sous anesthésie générale, en ambulatoire ou avec une courte hospitalisation. Un œdème et des ecchymoses sont attendus la première semaine ; la reprise d'une activité sociale est en général possible après 10 à 15 jours, le résultat définitif s'affinant progressivement sur plusieurs mois.",
        },
        {
          id: 2,
          slug: "blepharoplastie",
          title: "Blepharoplastie",
          overview:
            "La blépharoplastie traite l'excès de peau des paupières supérieures qui alourdit le regard, ainsi que les poches et le relâchement des paupières inférieures. Elle redonne un regard reposé sans modifier l'expression naturelle du visage.",
          consultation:
            "La consultation évalue la qualité de la peau, le tonus musculaire et la position des sourcils, afin de déterminer si une blépharoplastie seule suffit ou si un geste associé est nécessaire. D'anciennes photographies peuvent être utiles pour retrouver les caractéristiques naturelles du regard.",
          expect:
            "Réalisée sous anesthésie locale approfondie ou générale légère, l'intervention laisse des cicatrices dissimulées dans les plis naturels de la paupière, qui s'estompent en quelques semaines. Un léger œdème persiste 7 à 10 jours ; les activités habituelles reprennent généralement au bout d'une semaine.",
        },
        {
          id: 3,
          slug: "genioplastie",
          title: "Génioplastie",
          overview:
            "La génioplastie corrige un menton trop reculé, trop projeté ou asymétrique, afin de rétablir l'équilibre du profil et l'harmonie entre le nez, la bouche et le menton. Elle est parfois associée à une rhinoplastie pour retravailler l'ensemble du profil facial.",
          consultation:
            "Le Dr. Oliver analyse le profil et les proportions du visage, discute des différentes options — implant ou ostéotomie selon les cas — et définit avec vous l'amplitude de correction souhaitée, en tenant compte de l'équilibre global du visage.",
          expect:
            "Selon la technique retenue, l'intervention se déroule sous anesthésie locale approfondie ou générale. Un gonflement de la zone est habituel les premiers jours ; les résultats sont durables et se stabilisent progressivement sur plusieurs semaines.",
        },
        {
          id: 4,
          slug: "otoplastie",
          title: "Otoplastie",
          overview:
            "L'otoplastie corrige les oreilles décollées ou mal ourlées, en recréant les plis naturels du cartilage pour rapprocher les oreilles du crâne de façon symétrique et harmonieuse.",
          consultation:
            "La consultation permet d'évaluer la souplesse et la forme du cartilage, d'expliquer la technique de remodelage envisagée et de répondre aux questions, notamment lorsque l'intervention concerne un enfant ou un adolescent.",
          expect:
            "L'intervention est réalisée sous anesthésie locale ou générale selon l'âge du patient, avec un pansement compressif porté quelques jours puis un bandeau nocturne pendant plusieurs semaines. Les cicatrices, situées derrière l'oreille, deviennent invisibles une fois cicatrisées.",
        },
        {
          id: 5,
          slug: "lifting-facial",
          title: "Lifting Facial",
          overview:
            "Le lifting facial raffermit les tissus du visage et du cou relâchés par le temps, en repositionnant les plans profonds plutôt qu'en tendant simplement la peau, pour un résultat naturel et non figé.",
          consultation:
            "La consultation évalue la qualité de la peau, le degré de relâchement et les zones à traiter en priorité (ovale du visage, cou, sillons), afin de proposer une technique adaptée — lifting cervico-facial complet ou geste plus ciblé.",
          expect:
            "Réalisé sous anesthésie générale ou locale approfondie selon l'étendue du geste, le lifting entraîne un œdème et des ecchymoses pendant une dizaine de jours. La reprise d'une vie sociale est possible après 2 à 3 semaines, le résultat continuant de s'affiner pendant plusieurs mois.",
        },
        {
          id: 6,
          slug: "injections-acide-hyaluronique",
          title: "Injections d'Acide Hyaluronique",
          overview:
            "Les injections d'acide hyaluronique comblent les rides, restaurent les volumes du visage (pommettes, sillons nasogéniens, menton) et redessinent certains contours sans recourir à la chirurgie.",
          consultation:
            "La consultation identifie les zones à traiter et les volumes à restaurer, en tenant compte de la morphologie du visage et de l'effet naturel recherché, pour définir un plan de traitement personnalisé et progressif.",
          expect:
            "Le geste se pratique en cabinet, sans anesthésie générale, avec un résultat immédiat et un léger gonflement possible pendant 24 à 48 heures. Selon la zone traitée, l'effet dure généralement de 9 à 18 mois.",
        },
      ],
    },
    cabinet: {
      heading: "Le cabinet",
      office: {
        eyebrow: "Les locaux",
        paragraphs: [
          "Le cabinet est situé au **4ème étage** du 19 Rue de Metz, à Toulouse, avec **accès ascenseur**.",
          "Il se compose de deux espaces distincts : une salle de consultation dédiée aux échanges et au suivi des patients, et une salle de soins équipée pour les petits actes et procédures en cabinet.",
          "Les interventions chirurgicales sont réalisées au **CHU de Toulouse**, dans un environnement hospitalier sécurisé avec une équipe pluridisciplinaire.",
        ],
      },
      doctor: {
        title: "Chirurgien Plasticien · Spécialiste de la Face",
        paragraphs: [
          "Formée à la Faculté de Médecine de Paris, le Dr. Charlotte Oliver exerce la chirurgie plastique et reconstructrice de la face depuis plus de quinze ans. Chaque intervention est adaptée à la morphologie et aux attentes de chaque patient.",
          "Elle consulte à Toulouse et reçoit sur rendez-vous, après une première consultation approfondie au cours de laquelle elle prend le temps d'écouter vos attentes et d'établir un plan de soin personnalisé.",
        ],
        credentials: [
          "Diplômée de la Faculté de Médecine de Paris",
          "Spécialiste en Chirurgie Plastique et Reconstructrice",
          "Membre du Collège Français de Chirurgie Plastique",
          "Formation continue internationale",
        ],
      },
      team: {
        eyebrow: "Notre équipe",
        members: [
          {
            name: "Emmanuelle",
            role: "Secrétaire médicale | Aide opératoire",
            bio: "Emmanuelle est le premier contact du cabinet. Elle coordonne les rendez-vous, accompagne les patients à chaque étape de leur parcours et veille au bon déroulement des consultations.",
          },
        ],
      },
    },
    actualites: {
      heading: "Actualités",
      eyebrow: "Conférences & Publications",
      prevLabel: "Précédent",
      nextLabel: "Suivant",
      list: [
        {
          id: 1,
          title: "Congrès International de Chirurgie Plastique",
          location: "Paris, France",
          date: "Mars 2024",
          role: "Conférencière",
          description:
            "Présentation des dernières avancées en rhinoplastie de précision et techniques mini-invasives de la face.",
        },
        {
          id: 2,
          title: "Symposium Européen de Chirurgie Faciale",
          location: "Lyon, France",
          date: "Novembre 2023",
          role: "Intervenante",
          description:
            "Communication sur la féminisation faciale : protocoles personnalisés et résultats à long terme.",
        },
        {
          id: 3,
          title: "Journées Françaises de Chirurgie Esthétique",
          location: "Bordeaux, France",
          date: "Juin 2023",
          role: "Modératrice & Conférencière",
          description:
            "Table ronde sur l'éthique en chirurgie esthétique et l'importance de la consultation préopératoire.",
        },
        {
          id: 4,
          title: "Forum Méditerranéen de Médecine Esthétique",
          location: "Nice, France",
          date: "Février 2023",
          role: "Intervenante",
          description:
            "Présentation des protocoles innovants en comblement et rajeunissement non chirurgical du visage.",
        },
        {
          id: 5,
          title: "Congrès Mondial de Chirurgie Reconstructrice",
          location: "Genève, Suisse",
          date: "Octobre 2022",
          role: "Conférencière invitée",
          description:
            "Intervention sur la reconstruction faciale post-traumatique : expérience clinique et perspectives.",
        },
      ],
    },
    contact: {
      heading: "Nous Contacter",
      address: {
        label: "Adresse",
        line1: "19 Rue de Metz, 4ème étage",
        line2: "31000 Toulouse",
      },
      phone: { label: "Téléphone", value: "05 32 74 91 22" },
      email: { label: "Email", value: "secretaire@dr-oliver.com" },
      hours: {
        heading: "Horaires d'ouverture",
        list: [
          { day: "Lundi", hours: "Au bloc — consultations par email" },
          { day: "Mardi", hours: "8h30 – 18h00" },
          { day: "Mercredi", hours: "8h30 – 18h00" },
          { day: "Jeudi", hours: "Au bloc — consultations par email" },
          { day: "Vendredi", hours: "Au bloc — consultations par email" },
          { day: "Weekend", hours: "Fermé" },
        ],
      },
      form: {
        heading: "Nous écrire",
        namePlaceholder: "Nom complet",
        emailPlaceholder: "Adresse email",
        subjectDefault: "Sélectionnez un sujet",
        subjects: [
          { value: "General Inquiry", label: "Renseignement général" },
          { value: "Appointment", label: "Rendez-vous" },
          { value: "Support", label: "Support" },
        ],
        messagePlaceholder: "Votre message (max 500 caractères)",
        charCounter: (n) => `${n}/500 caractères`,
        submit: "Envoyer",
        submitting: "Envoi en cours...",
        errors: {
          nameRequired: "Veuillez entrer votre nom.",
          nameInvalid: "Le nom ne doit pas contenir de chiffres.",
          emailRequired: "Veuillez entrer votre adresse email.",
          emailInvalid: "Veuillez entrer une adresse email valide.",
          subjectRequired: "Veuillez sélectionner un sujet.",
          messageRequired: "Veuillez entrer votre message.",
          consentRequired:
            "Vous devez accepter la politique de confidentialité pour envoyer votre message.",
        },
        consentLabel:
          "J'accepte que mes données personnelles (nom, e-mail, message) soient utilisées par le cabinet du Dr Charlotte Oliver pour traiter ma demande. Consultez notre ",
        consentLink: "Politique de confidentialité",
        errorStatus: "Échec de l'envoi. Veuillez réessayer.",
      },
    },
    toast: {
      title: "Message envoyé ✓",
      body: "Merci pour votre message. Notre équipe vous contactera dans les 24 à 48 heures.",
    },
    footer: {
      subtitle: "Chirurgie Plastique et Reconstructrice de la Face",
      interventions: {
        heading: "Interventions",
        items: [
          "Rhinoplastie",
          "Blepharoplastie",
          "Génioplastie",
          "Lifting Facial",
        ],
      },
      cabinet: { heading: "Le cabinet", items: ["Notre cabinet"] },
      actualites: { heading: "Actualités", items: ["Conférences"] },
      contact: { heading: "Contact", items: ["Adresse", "RDV"] },
      cta: "Prendre Rendez-vous",
      copyright: `© ${new Date().getFullYear()} Dr. Charlotte Oliver. Tous droits réservés.`,
    },
    legalPages: {
      backLink: "← Retour au site",
      privacy: {
        title: "Politique de confidentialité",
        updated: "Dernière mise à jour : juin 2026",
        s1: {
          heading: "1. Responsable du traitement",
          text: "Le responsable du traitement des données collectées via ce site est :",
        },
        s2: {
          heading: "2. Données collectées",
          intro:
            "Lorsque vous utilisez le formulaire de contact, nous collectons les données suivantes :",
          list: [
            "Nom complet",
            "Adresse e-mail",
            "Objet de la demande",
            "Contenu du message",
          ],
          outro:
            "Aucune autre donnée n'est collectée. Ce site ne dépose aucun cookie et n'utilise aucun outil de suivi ou d'analyse.",
        },
        s3: {
          heading: "3. Finalité du traitement",
          prefix: "Vos données sont collectées ",
          bold: "uniquement pour répondre à votre demande de contact",
          suffix:
            ". Elles ne sont transmises à aucun tiers à des fins commerciales et ne sont pas utilisées à des fins de prospection ou de marketing.",
        },
        s4: {
          heading: "4. Base légale",
          prefix: "Le traitement de vos données repose sur votre ",
          bold: "consentement explicite",
          suffix:
            " (article 6(1)(a) du RGPD), donné en cochant la case prévue à cet effet dans le formulaire de contact.",
          note: "Note : si votre message contient des informations relatives à votre santé, nous vous recommandons de ne pas inclure de détails médicaux personnels dans le formulaire de contact et de les réserver à votre consultation.",
        },
        s5: {
          heading: "5. Transmission et sous-traitance",
          p1prefix:
            "Vos données sont transmises à notre adresse e-mail professionnelle via la plateforme ",
          p1suffix:
            " (Impressive Webs Ltd, Royaume-Uni), qui agit en qualité de sous-traitant. Cette plateforme n'utilise pas vos données à des fins propres.",
          p2prefix: "Le site est hébergé par ",
          p2suffix:
            " (101 Townsend St, San Francisco, CA 94107, États-Unis). Cloudflare peut traiter les données techniques de connexion dans le cadre de la sécurisation et de la distribution du site.",
        },
        s6: {
          heading: "6. Durée de conservation",
          text: "Vos données sont conservées le temps nécessaire au traitement de votre demande, dans le respect de nos obligations légales.",
        },
        s7: {
          heading: "7. Vos droits",
          intro:
            "Conformément au Règlement général sur la protection des données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants :",
          rights: [
            {
              bold: "Droit d'accès",
              desc: " — obtenir une copie de vos données",
            },
            {
              bold: "Droit de rectification",
              desc: " — corriger des données inexactes",
            },
            {
              bold: "Droit à l'effacement",
              desc: " — demander la suppression de vos données",
            },
            {
              bold: "Droit à la portabilité",
              desc: " — recevoir vos données dans un format structuré",
            },
            {
              bold: "Droit d'opposition",
              desc: " — vous opposer à un traitement",
            },
            {
              bold: "Droit de retrait du consentement",
              desc: " — retirer votre consentement à tout moment, sans que cela remette en cause la licéité du traitement effectué avant le retrait",
            },
          ],
          outro: "Pour exercer l'un de ces droits, contactez-nous à :",
        },
        s8: {
          heading: "8. Droit de réclamation auprès de la CNIL",
          prefix:
            "Si vous estimez que le traitement de vos données ne respecte pas la réglementation en vigueur, vous avez le droit d'introduire une réclamation auprès de la ",
          bold: "Commission Nationale de l'Informatique et des Libertés (CNIL)",
          suffix: " : ",
          address: "— 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07.",
        },
      },
      mentions: {
        title: "Mentions légales",
        updated: "Dernière mise à jour : juin 2026",
        s1: {
          heading: "Éditeur du site",
          phone: "Téléphone",
          siret: "SIRET",
          form: "Forme juridique",
          formValue: "SELARL, société d'exercice libéral à responsabilité limitée",
          rcs: "RCS",
          rcsValue: "988 859 849 R.C.S. Toulouse",
        },
        s2: { heading: "Directeur de la publication" },
        s3: {
          heading: "Hébergement",
          intro: "Ce site est hébergé et distribué par :",
        },
        s4: {
          heading: "Propriété intellectuelle",
          prefix:
            "L'ensemble du contenu de ce site (textes, photographies, graphismes, logo) est la propriété exclusive de ",
          suffix:
            " et est protégé par les dispositions du Code de la propriété intellectuelle. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation préalable écrite est interdite.",
        },
        s5: {
          heading: "Données personnelles",
          prefix:
            "Pour toute information sur la collecte et le traitement de vos données personnelles, consultez notre ",
          link: "Politique de confidentialité",
        },
        s6: {
          heading: "Contact",
          prefix: "Pour toute question relative à ce site :",
        },
      },
    },
  },

  en: {
    header: {
      subtitle: "Plastic and Reconstructive Surgery of the Face",
      nav: {
        interventions: "Procedures",
        cabinet: "Our Practice",
        actualites: "News",
        contact: "Contact",
      },
    },
    hero: {
      title: "Aesthetic Surgeon",
      tagline:
        "Plastic surgeon specialising in facial procedures, with a personalised and natural approach",
    },
    interventions: {
      heading: "Procedures",
      tocLabel: "Quick links to procedures",
      tocIntro: "Jump straight to:",
      labels: {
        overview: "What this procedure treats",
        consultation: "What the consultation involves",
        expect: "What to expect",
      },
      list: [
        {
          id: 1,
          slug: "rhinoplastie",
          title: "Rhinoplasty",
          overview:
            "Rhinoplasty corrects the shape, proportions or asymmetries of the nose — a dorsal hump, a drooping or bulbous tip, deviation, or a nose that feels out of balance with the rest of the face. It can also correct breathing difficulties caused by a deviated septum, combining a functional and an aesthetic goal in the same procedure.",
          consultation:
            "The first consultation examines the nose's anatomy, skin quality and breathing function, and takes time to understand your expectations in detail. Dr. Oliver reviews the techniques available — structural or ultrasonic rhinoplasty, with or without osteotomies — and, where helpful, simulates the expected outcome to keep the project realistic and in harmony with your face.",
          expect:
            "The procedure is performed under general anaesthesia, either as day surgery or with a short hospital stay. Swelling and bruising are expected during the first week; a return to social activities is usually possible after 10 to 15 days, with the final result refining gradually over several months.",
        },
        {
          id: 2,
          slug: "blepharoplastie",
          title: "Blepharoplasty",
          overview:
            "Blepharoplasty treats excess skin on the upper eyelids that weighs down the gaze, as well as puffiness and sagging of the lower eyelids. It restores a rested look without altering your natural expression.",
          consultation:
            "The consultation assesses skin quality, muscle tone and brow position to determine whether blepharoplasty alone is sufficient or should be combined with another procedure. Older photographs can be helpful in identifying the natural characteristics of your gaze.",
          expect:
            "Performed under deep local or light general anaesthesia, the procedure leaves scars hidden within the eyelid's natural folds, which fade within a few weeks. Mild swelling persists for 7 to 10 days; usual activities generally resume after about a week.",
        },
        {
          id: 3,
          slug: "genioplastie",
          title: "Genioplasty",
          overview:
            "Genioplasty corrects a chin that is too recessed, too prominent or asymmetrical, restoring balance to the profile and harmony between the nose, mouth and chin. It is sometimes combined with rhinoplasty to rework the facial profile as a whole.",
          consultation:
            "Dr. Oliver analyses the profile and facial proportions, discusses the available options — implant or osteotomy, depending on the case — and defines the desired degree of correction together with you, taking the overall balance of the face into account.",
          expect:
            "Depending on the technique used, the procedure is performed under deep local or general anaesthesia. Some swelling in the area is normal during the first days; results are long-lasting and settle gradually over several weeks.",
        },
        {
          id: 4,
          slug: "otoplastie",
          title: "Otoplasty",
          overview:
            "Otoplasty corrects protruding or poorly folded ears, recreating the cartilage's natural folds to bring the ears closer to the head in a symmetrical, harmonious way.",
          consultation:
            "The consultation assesses the flexibility and shape of the cartilage, explains the reshaping technique planned, and answers your questions — particularly when the procedure concerns a child or teenager.",
          expect:
            "The procedure is performed under local or general anaesthesia depending on the patient's age, with a compression dressing worn for a few days followed by a night band for several weeks. The scars, located behind the ear, become invisible once healed.",
        },
        {
          id: 5,
          slug: "lifting-facial",
          title: "Facelift",
          overview:
            "A facelift firms sagging tissue in the face and neck by repositioning the deeper structural layers rather than simply pulling the skin tight, for a natural, unfrozen result.",
          consultation:
            "The consultation assesses skin quality, the degree of sagging and the areas to prioritise (facial contour, neck, folds), in order to propose a suitable technique — a full cervico-facial lift or a more targeted procedure.",
          expect:
            "Performed under general or deep local anaesthesia depending on the extent of the procedure, a facelift causes swelling and bruising for about ten days. A return to social life is possible after 2 to 3 weeks, with the result continuing to refine over several months.",
        },
        {
          id: 6,
          slug: "injections-acide-hyaluronique",
          title: "Hyaluronic Acid Injections",
          overview:
            "Hyaluronic acid injections fill wrinkles, restore facial volume (cheekbones, nasolabial folds, chin) and redefine certain contours without surgery.",
          consultation:
            "The consultation identifies the areas to treat and the volumes to restore, taking facial morphology and the desired natural effect into account, to define a personalised, progressive treatment plan.",
          expect:
            "The treatment is carried out in-office, without general anaesthesia, with immediate results and possible mild swelling for 24 to 48 hours. Depending on the area treated, the effect typically lasts 9 to 18 months.",
        },
      ],
    },
    cabinet: {
      heading: "Our Practice",
      office: {
        eyebrow: "The premises",
        paragraphs: [
          "The practice is located on the **4th floor** of 19 Rue de Metz, Toulouse, with **lift access**.",
          "It consists of two distinct spaces: a consultation room dedicated to patient exchanges and follow-up, and a treatment room equipped for minor in-practice procedures.",
          "Surgical procedures are performed at the **CHU de Toulouse**, in a secure hospital environment with a multidisciplinary team.",
        ],
      },
      doctor: {
        title: "Plastic Surgeon · Facial Specialist",
        paragraphs: [
          "Trained at the Paris Faculty of Medicine, Dr. Charlotte Oliver has been practising plastic and reconstructive surgery of the face for over fifteen years. Each procedure is tailored to the anatomy and expectations of the individual patient.",
          "She consults in Toulouse and sees patients by appointment, following an in-depth initial consultation during which she takes the time to listen to your expectations and establish a personalised treatment plan.",
        ],
        credentials: [
          "Graduate of the Paris Faculty of Medicine",
          "Specialist in Plastic and Reconstructive Surgery",
          "Member of the French College of Plastic Surgery",
          "Ongoing international training",
        ],
      },
      team: {
        eyebrow: "Our team",
        members: [
          {
            name: "Emmanuelle",
            role: "Medical Secretary | Surgical Assistant",
            bio: "Emmanuelle is the first point of contact at the practice. She coordinates appointments, accompanies patients at every stage of their journey, and ensures consultations run smoothly.",
          },
        ],
      },
    },
    actualites: {
      heading: "News",
      eyebrow: "Conferences & Publications",
      prevLabel: "Previous",
      nextLabel: "Next",
      list: [
        {
          id: 1,
          title: "International Congress of Plastic Surgery",
          location: "Paris, France",
          date: "March 2024",
          role: "Speaker",
          description:
            "Presentation of the latest advances in precision rhinoplasty and minimally invasive facial techniques.",
        },
        {
          id: 2,
          title: "European Symposium of Facial Surgery",
          location: "Lyon, France",
          date: "November 2023",
          role: "Presenter",
          description:
            "Paper on facial feminisation: personalised protocols and long-term outcomes.",
        },
        {
          id: 3,
          title: "French Days of Aesthetic Surgery",
          location: "Bordeaux, France",
          date: "June 2023",
          role: "Moderator & Speaker",
          description:
            "Round table on ethics in aesthetic surgery and the importance of the preoperative consultation.",
        },
        {
          id: 4,
          title: "Mediterranean Forum of Aesthetic Medicine",
          location: "Nice, France",
          date: "February 2023",
          role: "Presenter",
          description:
            "Presentation of innovative protocols in filling and non-surgical facial rejuvenation.",
        },
        {
          id: 5,
          title: "World Congress of Reconstructive Surgery",
          location: "Geneva, Switzerland",
          date: "October 2022",
          role: "Guest Speaker",
          description:
            "Talk on post-traumatic facial reconstruction: clinical experience and perspectives.",
        },
      ],
    },
    contact: {
      heading: "Contact Us",
      address: {
        label: "Address",
        line1: "19 Rue de Metz, 4th floor",
        line2: "31000 Toulouse, France",
      },
      phone: { label: "Phone", value: "(0) 78 00 00 00" },
      email: { label: "Email", value: "secretaire@dr-oliver.com" },
      hours: {
        heading: "Opening Hours",
        list: [
          { day: "Monday", hours: "In surgery — enquiries by email" },
          { day: "Tuesday", hours: "8:30 am – 6:00 pm" },
          { day: "Wednesday", hours: "8:30 am – 6:00 pm" },
          { day: "Thursday", hours: "In surgery — enquiries by email" },
          { day: "Friday", hours: "In surgery — enquiries by email" },
          { day: "Weekend", hours: "Closed" },
        ],
      },
      form: {
        heading: "Write to us",
        namePlaceholder: "Full name",
        emailPlaceholder: "Email address",
        subjectDefault: "Select a subject",
        subjects: [
          { value: "General Inquiry", label: "General enquiry" },
          { value: "Appointment", label: "Appointment" },
          { value: "Support", label: "Support" },
        ],
        messagePlaceholder: "Your message (max 500 characters)",
        charCounter: (n) => `${n}/500 characters`,
        submit: "Send",
        submitting: "Sending...",
        errors: {
          nameRequired: "Please enter your name.",
          nameInvalid: "Name must not contain numbers.",
          emailRequired: "Please enter your email address.",
          emailInvalid: "Please enter a valid email address.",
          subjectRequired: "Please select a subject.",
          messageRequired: "Please enter your message.",
          consentRequired:
            "You must accept the privacy policy to send your message.",
        },
        consentLabel:
          "I consent to my personal data (name, email, message) being used by Dr Charlotte Oliver's practice to respond to my enquiry. See our ",
        consentLink: "Privacy Policy",
        errorStatus: "Failed to send. Please try again.",
      },
    },
    toast: {
      title: "Message sent ✓",
      body: "Thank you for your message. Our team will get back to you within 24 to 48 hours.",
    },
    footer: {
      subtitle: "Plastic and Reconstructive Surgery of the Face",
      interventions: {
        heading: "Procedures",
        items: ["Rhinoplasty", "Blepharoplasty", "Genioplasty", "Facelift"],
      },
      cabinet: { heading: "Our Practice", items: ["Our practice"] },
      actualites: { heading: "News", items: ["Conferences"] },
      contact: { heading: "Contact", items: ["Address", "Book"] },
      cta: "Book an Appointment",
      copyright: `© ${new Date().getFullYear()} Dr. Charlotte Oliver. All rights reserved.`,
    },
    legalPages: {
      backLink: "← Back to website",
      privacy: {
        title: "Privacy Policy",
        updated: "Last updated: June 2026",
        s1: {
          heading: "1. Data Controller",
          text: "The data controller for this website is:",
        },
        s2: {
          heading: "2. Data Collected",
          intro:
            "When you use the contact form, we collect the following data:",
          list: [
            "Full name",
            "Email address",
            "Subject of inquiry",
            "Message content",
          ],
          outro:
            "No other data is collected. This site uses no cookies, tracking, or analytics of any kind.",
        },
        s3: {
          heading: "3. Purpose of Processing",
          prefix: "Your data is collected ",
          bold: "solely to respond to your enquiry",
          suffix:
            ". It is not shared with any third party for commercial purposes, nor used for prospecting or marketing.",
        },
        s4: {
          heading: "4. Legal Basis",
          prefix: "The processing of your data is based on your ",
          bold: "explicit consent",
          suffix:
            " (Article 6(1)(a) GDPR), given by ticking the checkbox in the contact form.",
          note: "Note: if your message contains information relating to your health, we recommend not including personal medical details in the contact form and keeping these for your consultation.",
        },
        s5: {
          heading: "5. Data Transmission & Sub-processors",
          p1prefix: "Your data is sent to our professional email address via ",
          p1suffix:
            " (Impressive Webs Ltd, United Kingdom), acting as a data processor. This platform does not use your data for its own purposes.",
          p2prefix: "This website is hosted by ",
          p2suffix:
            " (101 Townsend St, San Francisco, CA 94107, USA). Cloudflare may process technical connection data as part of website security and delivery.",
        },
        s6: {
          heading: "6. Retention Period",
          text: "Your data is retained for as long as necessary to process your request, in compliance with our legal obligations.",
        },
        s7: {
          heading: "7. Your Rights",
          intro:
            "Under the General Data Protection Regulation (GDPR), you have the following rights:",
          rights: [
            { bold: "Right of access", desc: " — obtain a copy of your data" },
            {
              bold: "Right to rectification",
              desc: " — correct inaccurate data",
            },
            {
              bold: "Right to erasure",
              desc: " — request the deletion of your data",
            },
            {
              bold: "Right to portability",
              desc: " — receive your data in a structured format",
            },
            { bold: "Right to object", desc: " — object to processing" },
            {
              bold: "Right to withdraw consent",
              desc: " — withdraw consent at any time, without affecting the lawfulness of prior processing",
            },
          ],
          outro: "To exercise any of these rights, contact us at:",
        },
        s8: {
          heading: "8. Right to Lodge a Complaint",
          prefix:
            "If you believe that the processing of your data does not comply with applicable law, you have the right to lodge a complaint with ",
          bold: "the French data protection authority (CNIL)",
          suffix: ": ",
          address: "— 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07.",
        },
      },
      mentions: {
        title: "Legal Notice",
        updated: "Last updated: June 2026",
        s1: {
          heading: "Website Publisher",
          phone: "Phone",
          siret: "SIRET",
          form: "Legal form",
          formValue: "SELARL, French limited liability company for regulated professions",
          rcs: "RCS",
          rcsValue: "988 859 849 R.C.S. Toulouse",
        },
        s2: { heading: "Publication Director" },
        s3: {
          heading: "Hosting",
          intro: "This website is hosted and distributed by:",
        },
        s4: {
          heading: "Intellectual Property",
          prefix:
            "All content on this website (text, photographs, graphics, logo) is the exclusive property of ",
          suffix:
            " and is protected by applicable intellectual property law. Any reproduction, representation or distribution, in whole or in part, without prior written authorisation is prohibited.",
        },
        s5: {
          heading: "Personal Data",
          prefix:
            "For information on the collection and processing of your personal data, please read our ",
          link: "Privacy Policy",
        },
        s6: {
          heading: "Contact",
          prefix: "For any questions about this website:",
        },
      },
    },
  },
};
